// Copyright 2020 Sorama B.V.

import { IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { FarFieldAnalysisGuidanceCatalog } from "catalogs/GuidanceCatalog/FarFieldAnalysisGuidanceCatalog";
import { NearFieldAnalysisGuidanceCatalog } from "catalogs/GuidanceCatalog/NearFieldAnalysisGuidanceCatalog";
import { SpectralTimeAnalysisGuidanceCatalog } from "catalogs/GuidanceCatalog/SpectralTimeAnalysisGuidanceCatalog";
import { StreamingGuidanceCatalog } from "catalogs/GuidanceCatalog/StreamingGuidanceCatalog";
import { TechnicalTroubleshootingGuidanceCatalog } from "catalogs/GuidanceCatalog/TechnicalTroubleshootingGuidanceCatalog";
import { GettingStartedGuidanceCatalog } from "./../catalogs/GuidanceCatalog/GettingStartedGuidanceCatalog";

export class TeaserQuestions {
    static readonly questions: { question: string; topic?: IGuidanceTopic | URL }[] = [
        // General
        {
            question: "You can easily buy credits via our Website",
            topic: new URL("https://www.sorama.eu/customer-service"),
        },
        {
            question: "The LED colors on your Sorama Camera have a meaning",
            topic: TechnicalTroubleshootingGuidanceCatalog.TechnicalTroubleshootingGS1Module,
        },
        { question: "You can copy the URL of your analysis, and save it for later use" },

        // Analyze
        {
            question: "With the continuous presence of a targeted frequency, you can select ‘Time Average’ mode",
            topic: FarFieldAnalysisGuidanceCatalog.FarFieldAnalysisOverviewModule,
        },
        {
            question: "In a far field analysis, the resolution is determined by the frequency of the source",
            topic: FarFieldAnalysisGuidanceCatalog.FarFieldAnalysisOverviewModule,
        },
        {
            question: "In near field analysis the resolution is determined by the spacing between the microphones",
            topic: NearFieldAnalysisGuidanceCatalog.NearFieldAnalysisOverviewModule,
        },
        {
            question: "You can listen to a point in a far field result, by clicking on the image",
            topic: FarFieldAnalysisGuidanceCatalog.FarFieldAnalysisOverviewModule,
        },
        {
            question: "You can download a time signal as a wav file",
            topic: SpectralTimeAnalysisGuidanceCatalog.SpectralTimeAnalysisOverviewModule,
        },

        // Streaming
        {
            question: "Streaming is free and therefore a great way to get a first impression",
            topic: StreamingGuidanceCatalog.StreamingOverviewModule,
        },
        { question: "streaming is possible without internet", topic: StreamingGuidanceCatalog.StreamingOverviewModule },

        // Measurement
        { question: "A scanning measurement increases the area of interest" },
        {
            question: "A higher resolution near field result can be achieved with a scanning measurement",
            topic: TechnicalTroubleshootingGuidanceCatalog.TechnicalTroubleshootingGS3Module,
        },
        {
            question: "How to optimally prepare for your measurement?",
            topic: GettingStartedGuidanceCatalog.GettingStartedGS1Module,
        },
        { question: "Measurements can be made without internet" },
    ];
}
